import { useContext, useEffect } from 'react';
import { BonusRecordTaggingContext } from './BonusRecordTaggingProvider';
import Typography from '../../../../kingpin/atoms/Typography';
import styled from 'styled-components';
import { BonusOverviewContext } from '../../providers/BonusOverviewProvider';
import RecordTaggingGrid from './RecordTaggingGrid';
import Icon from '../../../../kingpin/atoms/Icon';
import GridProvider from '../../../../contextProviders/GridProvider';

const PageContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: scroll;
`;

const BonusResultsDiv = styled.div`
  display: flex;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid var(--color-border-secondary);
`;

const BonusRecordTagging = () => {
  const { gridConfig, dateScopeOverride, setDateScopeOverride } = useContext(
    BonusRecordTaggingContext,
  );
  const { currentMode, bonusOverview } = useContext(BonusOverviewContext);

  if (!bonusOverview) {
    const e = new Error();
    e.name = 'No Bonus Overview found';
    throw e;
  }

  useEffect(() => {
    setDateScopeOverride({
      startDate: bonusOverview?.bonusPeriod.startDate,
      endDate: bonusOverview?.bonusPeriod.endDate,
      dateField: 'date',
    });
  }, [
    bonusOverview?.bonusPeriod.endDate,
    bonusOverview?.bonusPeriod.startDate,
    setDateScopeOverride,
  ]);

  return (
    <PageContainer>
      <div>
        <Typography.Header type={'H3'}>
          <span>Results</span>
        </Typography.Header>
      </div>
      <BonusResultsDiv>
        <span style={{ margin: '10px 12px 0px 0px' }}>
          <Icon
            width={25}
            height={25}
            icon={
              currentMode.taggableField?.passed ? 'circleCheckmark' : 'warning'
            }
            color={'var(--color-grey-7)'}
          />
        </span>
        <div>
          <Typography.Header type={'H3'} color={'var(--color-grey-3)'}>
            {currentMode.taggableField?.displayName}
          </Typography.Header>
          <Typography.Header type={'H3'}>
            {currentMode.taggableField?.actual}/
            {currentMode.taggableField?.target}
          </Typography.Header>
        </div>
      </BonusResultsDiv>
      {gridConfig && (
        <GridProvider
          dateScopeOverride={dateScopeOverride}
          dataType={gridConfig.dataType}
        >
          <RecordTaggingGrid gridConfig={gridConfig} />
        </GridProvider>
      )}
    </PageContainer>
  );
};

export default BonusRecordTagging;
